import React from 'react';
import './Footer.css';
import logo from '../assets/logo-footer.png'; // ✅ adjust path if needed

function Footer() {
  return (
    <footer className="footer">
      <div className="footer-container">
        
        {/* Logo and company info */}
        <div className="footer-section footer-logo">
         <h4 className="h5">GÖKÇE CAPITAL INVESTMENTS PVT. LTD.</h4>
          <p className="w3-widew3-small">
            Empowering Investments to Soar
          </p>

          <p>info@gokce.in</p>
        </div>

        {/* Quick Links */}
        <div className="footer-section w3-hide-small">
          <h4>Quick Links</h4>
          <ul>
            <li><a href="/aboutus">Who we are </a></li>

            <li><a href="/team">Team</a></li>
            <li><a href="/services"> What we do</a></li>

            <li><a href="/services">Portfolio</a></li>
            <li><a href="/contact">Contact</a></li>
          </ul>
        </div>
 


        {/* Contact Info */}
        <div className="footer-section">
         <h4>India</h4>
          <div className="office">
            <h5>Gurugram</h5>
            <p>AF-005-007, 1st Floor, Conscient One<br />Sector 109, Gurugram, Haryana 122006</p>
          </div>
        </div>


        {/* Contact Info */}
        <div className="footer-section">
          <h4></h4>
        </div>

      </div>


      {/* Bottom line */}
      <div className="footer-bottom">
        <p>
          © {new Date().getFullYear()} IndoDefTech. All rights reserved. &nbsp;|&nbsp;
          <a href="/privacy-policy" className="footer-link">Privacy Policy</a> &nbsp;|&nbsp;
          <a href="/terms" className="footer-link">Terms & Conditions</a>
        </p>
      </div>
    </footer>
  );
}

export default Footer;
